import { Stack, Tooltip, Typography } from "@mui/material";

import { useShipmentPageContext } from "hooks";
import {
  capitalizeFirst,
  equipmentTypeInEquipmentList,
  formatText,
} from "utils";

interface QuoteEquipmentDisplayProps {
  equipmentType: string | undefined;
}

export function QuoteEquipmentDisplay(props: QuoteEquipmentDisplayProps) {
  const { equipmentType } = props;
  const { shipment } = useShipmentPageContext();

  const isEquipmentMatch = equipmentTypeInEquipmentList(
    equipmentType,
    shipment?.equipments,
  );

  if (equipmentType && !isEquipmentMatch) {
    return (
      <Tooltip title="Quote equipment differs from shipment requested equipment">
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            backgroundColor: "rgba(255, 235, 59, 0.2)",
            padding: 0.5,
            borderRadius: 1,
          }}
        >
          <Typography>
            <b>Equipment: </b>
            {equipmentType ? capitalizeFirst(formatText(equipmentType)) : "-"}
          </Typography>
        </Stack>
      </Tooltip>
    );
  }
  return (
    <Stack>
      <Typography>
        <b>Equipment: </b>
        {equipmentType ? capitalizeFirst(formatText(equipmentType)) : "-"}
      </Typography>
    </Stack>
  );
}
